import { memo } from "react";
import { View, Pressable } from "react-native";
import { usePostHog } from "posthog-js/react";
import SettingsItem from "../common/settings-item";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import { Slider } from "../../../common/shadcn/slider";
import StyledText from "../../../common/ui/styled-text";
import { FastForward, Rewind, Sliders } from "lucide-react-native";

const VoiceSpeedSetting = () => {
  const posthog = usePostHog();
  const { settings, handleVoiceSpeed, isTestCallActive } = useSettingsData();

  return (
    <View>
      <SettingsItem
        title="Voice Speed"
        description="Adjust how slowly or quickly your A.I. assistant speaks."
        icon={Sliders}
      >
        <View className="flex-col mx-2 sm:mx-4">
          <View className="w-full relative">
            <Slider
              value={[settings.voiceSpeed]}
              onValueChange={([value]) => handleVoiceSpeed(value)}
              min={0}
              max={100}
              trackColor="#e5e7eb"
              thumbColor="#1f2937"
              step={10}
              marks={[0, 10, 20, 30, 40, 60, 70, 80, 90, 100]}
              smallMarks={[10, 30, 70, 90]}
              disabled={isTestCallActive}
            />
            <Pressable
              onPress={() => {
                posthog.capture("voice_speed_selected", {
                  voice_speed: 50,
                });
                handleVoiceSpeed(50);
              }}
              className="absolute items-center top-[6px] -z-10 w-8 left-[calc(50%-16px)] cursor-pointer"
              disabled={isTestCallActive}
            >
              <View className="w-1 h-4 bg-[#e5e7eb]"></View>
              <StyledText className="text-center text-xs text-gray-500">
                Normal
              </StyledText>
            </Pressable>
          </View>
          <View className="flex-row justify-between items-center mt-4">
            <Pressable
              className="flex-col items-center"
              onPress={() => {
                posthog.capture("voice_speed_selected", {
                  voice_speed: 0,
                });
                handleVoiceSpeed(0);
              }}
              disabled={isTestCallActive}
            >
              <Rewind size={16} color="#374151" />
              <StyledText className="text-xs text-gray-500">Slowest</StyledText>
            </Pressable>
            <Pressable
              className="flex-col items-center"
              onPress={() => {
                posthog.capture("voice_speed_selected", {
                  voice_speed: 100,
                });
                handleVoiceSpeed(100);
              }}
              disabled={isTestCallActive}
            >
              <FastForward size={16} color="#374151" />
              <StyledText className="text-xs text-gray-500">Fastest</StyledText>
            </Pressable>
          </View>
        </View>
      </SettingsItem>
    </View>
  );
};

export default memo(VoiceSpeedSetting);
